import { useTranslation } from 'react-i18next';

import { CategoryCard } from '../components/catalog/CategoryCard';
import { Loader } from '../components/ui/Loader';
import { useGetCategoriesQuery, useGetHideProductsStatusQuery } from '../store/api/catalogApi';

export function CatalogPage() {
  const { t } = useTranslation();
  const { data: hideData } = useGetHideProductsStatusQuery();
  const isHidden = hideData?.data?.hideProducts?.website === true;
  const { data, isLoading, error } = useGetCategoriesQuery({ level: 'top' }, { skip: isHidden });

  if (isHidden) {
    return (
      <div className="min-h-screen">
        <div className="card-glass rounded-2xl shadow-2xl p-8 text-center max-w-lg mx-auto mt-16">
          <h2 className="text-2xl font-heading font-bold text-neutral-medium mb-4">
            {t('catalog.hidden')}
          </h2>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen">
        <div className="flex justify-center items-center py-16">
          <Loader />
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="min-h-screen">
        <div className="card-glass rounded-2xl shadow-2xl p-8 text-center">
          <h2 className="text-2xl font-heading font-bold text-danger mb-4">
            {t('catalog.error.title')}
          </h2>
          <p className="text-neutral-medium font-body mb-6">
            {'data' in (error as { data?: { message?: string } })
              ? ((error as { data?: { message?: string } })?.data?.message || t('errors.network'))
              : t('errors.network')}
          </p>
        </div>
      </div>
    );
  }

  const categories = data.data.categories;

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="mb-8 text-center animate-slide-up">
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-accent mb-4">
          {t('catalog.title')}
        </h1>
        <p className="text-neutral-medium text-lg font-body">
          {t('catalog.subtitle')}
        </p>
      </div>

      {/* Categories Grid */}
      {categories.length === 0 ? (
        <div className="card-glass rounded-2xl shadow-2xl p-8 text-center">
          <p className="text-neutral-medium text-lg font-body">
            {t('catalog.empty')}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-scale-in">
          {categories.map((category) => (
            <CategoryCard key={category._id} category={category} />
          ))}
        </div>
      )}
    </div>
  );
}

